export interface APIImageBoxProps {
  id: number // API only
  name: string
  description: string
  image: string
  image2: string,
  image3: string,
  image4: string,
  image5: string
  coord: string
  extra: string // API / Filtering only, not used in this component
  startYear: string
  endYear: string
}

export interface ImageBoxData {
  id: number // API only
  name: string
  description: string
  descriptionRo: string
  images: string[]
  coord: string
  coordRo: string
  extra: string // API / Filtering only, not used in this component
  extraDescription: string,
  extraDescriptionRo: string,
  startYear: number
  endYear: number
}

export const DUMMY_IMAGE_BOX_PROP = {
  id: 0,
  name: '',
  description: '',
  image: '',
  image2: '',
  image3: '',
  image4: '',
  image5: '',
  coord: '',
  coordRo: '',
  extra: '',
  descriptionRo: '',
  extraDescription: '',
  extraDescriptionRo: '',
  startYear: 0,
  endYear: 0,
}
